import Login from '../pages/login';
import Register from '../pages/register';
import ForgotPassword from '../pages/forgot-password';
import Dashboard from '../pages/dashboard';
import ResetPassword from '../pages/reset-password';
import RegisterThankingNote from '../pages/register-thanking-note';
import NotFound from '../components/NotFound';
import ContainerRouter from '../components/ContainerRouter';
import AssignedPortfolio from '../Views/Portfolio/AssignedPortfolio';
import ApprovedPortfolio from '../Views/Portfolio/ApprovedPortfolio';
import ViewPortfolio from '../Views/Portfolio/ViewPortfolio';
import PortfolioDashboard from '../Views/Portfolio/Dashboard';
import ViewUser from '../pages/view-user';
import ManageUsers from '../pages/manage-users';
import ViewRole from '../pages/view-role';
import ManageRoles from '../pages/manage-roles';
import ChangePassword from '../pages/change-password';

export default [
	{
		component: Login,
		path: '/lender/login',
		title: 'login',
		exact: true,
		type: 'lender',
	},
	{
		component: Register,
		path: '/lender/register',
		title: 'register',
		exact: true,
	},
	{
		component: RegisterThankingNote,
		path: '/lender/register/thank-you',
		title: 'register',
		exact: true,
	},
	{
		component: ForgotPassword,
		path: '/lender/password/forget',
		title: 'forgotPassword',
		exact: true,
	},
	{
		component: ResetPassword,
		path: '/lender/password/reset',
		title: 'resetPassword',
		exact: true,
	},
	{
		component: ContainerRouter,
		path: '/*',
		title: 'container',
		type: 'lender',
	},
	{
		component: AssignedPortfolio,
		path: '/',
		title: 'assignedPortfolio',
		exact: true,
		private: true,
		customComponentProps: { leadType: 'assigned' },
	},
	{
		component: ViewPortfolio,
		path: '/portfolio/view/:id/*',
		private: true,
	},
	{
		component: AssignedPortfolio,
		path: '/portfolio/assigned',
		title: 'assignedPortfolio',
		exact: true,
		private: true,
		customComponentProps: { leadType: 'assigned' },
	},
	{
		component: AssignedPortfolio,
		path: '/portfolio/sanction-rejected',
		title: 'sanctionrejectedPortfolio',
		exact: true,
		private: true,

		customComponentProps: { leadType: 'rejected' },
	},
	{
		component: ApprovedPortfolio,
		path: '/portfolio/disbursal-pending',
		title: 'disbursalPendingPortfolio',
		exact: true,
		private: true,
		customComponentProps: { leadType: 'disbursal-pending' },
	},
	{
		component: ApprovedPortfolio,
		path: '/portfolio/disbursal-approved',
		title: 'disbursalPendingPortfolio',
		exact: true,
		private: true,
		customComponentProps: { leadType: 'disbursal-approved' },
	},
	{
		component: ApprovedPortfolio,
		path: '/portfolio/disbursal-rejected',
		title: 'disbursalRejectedPortfolio',
		exact: true,
		private: true,
		customComponentProps: { leadType: 'disbursal-rejected' },
	},

	{
		component: ApprovedPortfolio,
		path: '/portfolio/approved',
		title: 'assignedPortfolio',
		exact: true,
		private: true,
		customComponentProps: { leadType: 'approve' },
	},
	{
		component: PortfolioDashboard,
		path: '/portfolio/dashboard',
		title: 'portfolioDashboard',
		exact: true,
		private: true,
	},
	{
		component: ManageUsers,
		path: '/lender/manage-users',
		title: 'manageUsers',
		exact: true,
		private: true,

		customComponentProps: { type: 'lender' },
	},
	{
		component: ViewUser,
		path: '/lender/manage-users/add',
		title: 'addUser',
		exact: true,
		private: true,

		customComponentProps: { type: 'lender' },
	},
	{
		component: ViewUser,
		path: '/lender/manage-users/edit/:userId',
		title: 'editUser',
		exact: true,
		private: true,

		customComponentProps: { type: 'lender' },
	},

	{
		component: ViewUser,
		path: '/lender/manage-users/:userId',
		title: 'viewUsers',
		exact: true,
		private: true,

		customComponentProps: { type: 'lender' },
	},
	{
		component: ViewRole,
		path: '/lender/role/add',
		title: 'manageRole',
		exact: true,
		private: true,
		customComponentProps: { type: 'lender' },
	},
	{
		component: ViewRole,
		path: '/lender/role/:roleId',
		title: 'manageRole',
		exact: true,
		private: true,
		customComponentProps: { type: 'lender' },
	},
	{
		component: ViewRole,
		path: '/lender/role/edit/:roleId',
		title: 'manageRole',
		exact: true,
		private: true,
		customComponentProps: { type: 'lender' },
	},
	{
		component: ManageRoles,
		path: '/lender/roles',
		title: 'manageRole',
		exact: true,
		private: true,
		customComponentProps: { type: 'lender' },
	},
	{
		component: ChangePassword,
		path: '/password/change',
		title: 'changePassword',
		exact: true,
		private: true,
	},
	{ component: NotFound, path: '*' },
];
